// extracted by mini-css-extract-plugin
export default {"nav":"navSuperior_nav__Y6BCO"};